import React from 'react'

const PaginationV2 = ({
  startIndex,
  endIndex,
  totalItems,
  currentPage,
  totalPages,
  onPageChange,
  itemLabel = 'events',
  isMobileView = false,
}) => {
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1)
    }
  }

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1)
    }
  }

  return (
    <footer className="flex flex-wrap items-center justify-between gap-3 border-t border-customAccent/10 px-5 py-4 text-sm text-customSecondaryText dark:border-customSurfaceMuted dark:text-customMuted">
      {isMobileView ?
        <span>Totals : {totalItems}</span> :
        <span>
          Showing {totalItems === 0 ? 0 : startIndex}-{totalItems === 0 ? 0 : endIndex} of {totalItems}{' '}
          {itemLabel}
        </span>
      }
      <div className="flex items-center gap-2">
        <button
          type="button"
          className="rounded-lg border border-customAccentBlue/30 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-customAccentBlue transition hover:border-customAccentBlue/50 bg-customAccentBlue/10 disabled:cursor-not-allowed disabled:border-customAccent/20 disabled:text-customAccent/40 dark:border-customSurfaceMuted dark:text-customHeading"
          onClick={handlePrevious}
          disabled={currentPage === 1 || totalItems === 0}
        >
          Previous
        </button>
        <span className="text-xs font-semibold text-customPrimaryText dark:text-customHeading">
          {totalItems === 0 ? '0 / 0' : `${currentPage} / ${totalPages}`}
        </span>
        <button
          type="button"
          className="rounded-lg border border-customAccentBlue/30 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-customAccentBlue transition hover:border-customAccentBlue/50 bg-customAccentBlue/10 disabled:cursor-not-allowed disabled:border-customAccent/20 disabled:text-customAccent/40 dark:border-customSurfaceMuted dark:text-customHeading"
          onClick={handleNext}
          disabled={totalItems === 0 || currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </footer>
  )
}

export default PaginationV2
